import { useEffect, useState } from "react";
import * as util from "../Helpers/Util";
import queryString from "query-string";
import history from "../../history";
import ruhsatTipiSorgula from "../../services/ruhsatTipiSorgula";
import parentBasvuruRuhsatTipiSorgula from "../../services/parentBasvuruRuhsatTipiSorgula";
import parentBasvuruRuhsatTipiGuncelle from "../../services/parentBasvuruRuhsatTipiGuncelle";
import {
    Form,
    Select,
    Col,
    Button,
    Row,
    Spin
} from "antd";
const { Option } = Select;

const parsed = queryString.parse(history.location.search);

const formItemStyle = {
    marginLeft: 20,
    marginTop: 20
};

const ParentBasvuruRuhsatTipiForm = () => {
    const [form] = Form.useForm();
    const [spining, setSpining] = useState(false);
    const [ruhsatTipiList, setRuhsatTipiList] = useState();
    const [basvuruRuhsatTipiIdList, setBasvuruRuhsatTipiIdList] = useState([]);
    const [formReadonly, setFormReadonly] = useState(false);

    const loadForm = async () => {
        setSpining(true);
        await parentBasvuruRuhsatTipiSorgula(parsed.parentObjectId).then((resp) => {
            if (resp.data.success) {
                setBasvuruRuhsatTipiIdList(resp.data.result.basvuruRuhsatTipiList);
                form.setFieldsValue({
                    RuhsatTipiIdList: resp.data.result.basvuruRuhsatTipiList
                });
                form.getFieldsValue();
                setFormReadonly(resp.data.result.isReadonly);
            } else {
                util.errorMessage(resp.data.message);
            }
        }).catch((ex) => {
            util.errorMessage(String(ex.message));
        });

        await ruhsatTipiSorgula().then((resp) => {
            if (resp.data.success) {
                setRuhsatTipiList(resp.data.result);
            } else {
                util.errorMessage(resp.data.message);
            }
        }).catch((ex) => {
            util.errorMessage(String(ex.message));
        });

        setSpining(false);
    };
    useEffect(() => {
        loadForm();
    }, []);

    const onFinish = async () => {
        setSpining(true);
        var data = {
            parentObjectId: parsed.parentObjectId,
            ruhsatTipiIdList: basvuruRuhsatTipiIdList
        };
        await parentBasvuruRuhsatTipiGuncelle(data).then(resp => {
            if (resp.data.success) {
                util.successMessage(resp.data.message);
                window.parent.location.reload();
            } else {
                util.errorMessage(resp.data.message);
            }
        }).catch(ex => {
            util.errorMessage(String(ex.message))
        });
        setSpining(false);

    };

    return (
        <Spin tip={"Veriler Yükleniyor"}
            spinning={spining}>
            <Form form={form}
                onFinish={onFinish}

            >
                <Col span={20}>
                    <Form.Item label="Ruhsat Tipi" name="RuhsatTipiIdList"

                        style={formItemStyle}
                        labelAlign="left">
                        {
                            <Select mode="tags" placeholder="Ruhsat Tipi"
                                onChange={(val) => setBasvuruRuhsatTipiIdList(val)}
                                disabled={formReadonly}>
                                {
                                    ruhsatTipiList && ruhsatTipiList.map((bt) => (
                                        <Option key={
                                            bt.objectid
                                        }
                                            value={
                                                bt.objectid
                                            }>
                                            {
                                                bt.adi
                                            } </Option>
                                    ))
                                } </Select>



                        }
                    </Form.Item>
                </Col>
                <Row>
                    <Col span={20}
                        style={
                            { textAlign: "right" }
                        }>
                        <Button type="primary" htmlType="submit">
                            Güncelle
                        </Button>
                    </Col>
                </Row>
            </Form>
        </Spin>
    );
};

export default ParentBasvuruRuhsatTipiForm;

